import React from "react";
import "./bar.css";
function bar() {
  return (
    <div>
      <section class="skills section" id="skills">
        <div class="skills__container bd-grid">
          <div>
            <p class="skills__text"></p>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxl-html5 skills__icon"></i>
                <span class="skills__name">HTML5</span>
              </div>

              <div class="skills__bar skills__html"></div>
            </div>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxl-css3 skills__icon"></i>
                <span class="skills__name">CSS</span>
              </div>
              <div class="skills__bar skills__js"></div>
            </div>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxl-javascript skills__icon"></i>
                <span class="skills__name">JAVASCRIPT</span>
              </div>
              <div class="skills__bar skills__css"></div>
            </div>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxl-react skills__icon"></i>
                <span class="skills__name">REACT.JS</span>
              </div>
              <div class="skills__bar skills__ux"></div>
            </div>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxl-react skills__icon"></i>
                <span class="skills__name">REACT-NATIVE</span>
              </div>
              <div class="skills__bar skills__ux"></div>
            </div>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxl-sass skills__icon"></i>
                <span class="skills__name">NODE.JS</span>
              </div>
              <div class="skills__bar skills__ux"></div>
            </div>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxl-wordpress skills__icon"></i>
                <span class="skills__name">MONGO-DB</span>
              </div>
              <div class="skills__bar skills__ux"></div>
            </div>
            <div class="skills__data">
              <div class="skills__names">
                <i class="bx bxs-paint skills__icon"></i>
                <span class="skills__name">UI/UX</span>
              </div>
              <div class="skills__bar skills__ux"></div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default bar;
